import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'


import { employerAdminUrl } from 'app/types'
import PaymentSuccess from './components/PaymentSuccess'
import EmployerAdminDashboard from './components/EmployerAdminDashboard'
import { RecruiterRoutes } from '../recruiter/RecruiterPage'
import { ManageProfile } from '../shared/account/manage-profile'

export const EmployerAdminRoutes = {
  ManageBoothInfo: `${employerAdminUrl}/manage-booth-info/:boothId`,
  Dashboard: `${employerAdminUrl}/dashboard`,
  CheckoutPage: `${employerAdminUrl}/checkout`,
  PaymentSuccess: `${employerAdminUrl}/payment-success`,
  Profile: `${employerAdminUrl}/profile`
}

interface EAPageHOCProps {
  children: React.ReactNode;
  withContinuePopup?: boolean;
}

const EAPageHOC = (hocProps: EAPageHOCProps) => {
  return (<>
    {hocProps.children}
  </>);
}

const EmployerAdminPage: React.FC = (props) => {

  return (
    <Switch>
      <Route path={EmployerAdminRoutes.Dashboard} render={() => <EAPageHOC withContinuePopup={false}> <EmployerAdminDashboard /> </EAPageHOC>} />
      <Route path={EmployerAdminRoutes.PaymentSuccess} render={() => <EAPageHOC withContinuePopup={false}> <PaymentSuccess /></EAPageHOC>} />
      <Route path={EmployerAdminRoutes.Profile} render={() => <EAPageHOC withContinuePopup={false}> <ManageProfile title='Profile' /></EAPageHOC>} />

      <Redirect from={employerAdminUrl} to={RecruiterRoutes.Booth} />
      <Redirect to={RecruiterRoutes.Booth} />
    </Switch>
  )
}

export default EmployerAdminPage
